module.exports = __webpack_public_path__ + "static/media/house6.1719376e.png";